module.exports = __webpack_public_path__ + "static/img/icon.9ffddbe1.png";